import { Component, OnInit } from '@angular/core';
import { PowerBiConfig } from '../../models/power-bi-config.model';
import { FormGroup, FormControl } from '@angular/forms';
import { DwMdSectionConfigBaseComponent2, DwMdSectionConfigBaseComponent, DwComponentSectionConfigPreference, DwMdItem, DwMdAttribute, 
         DwContextMetaData, DwQueryMdAttribute } from '@devwareapps/devware-cap';

@Component({
  selector: 'app-power-bi-config',
  templateUrl: './power-bi-config.component.html'
})
export class PowerBiConfigComponent extends DwMdSectionConfigBaseComponent2<DwComponentSectionConfigPreference<PowerBiConfig>> {
  itemMetaData: DwMdItem;
  configFormGroup: FormGroup;
  contextMetaData: {dwQueryMdAttribute: DwQueryMdAttribute, dwContextMetaData: DwContextMetaData, Display: string }[] = [];

  filtersContext: FormControl;
  setupForm() {
    this.setupAttributeList();
    //this.setupContextList();
    this.filtersContext = new FormControl();
    this.configFormGroup = new FormGroup({
      reportId: new FormControl(),
      workspaceId: new FormControl(),
      filters: new FormControl(),
      filtersContext: this.filtersContext,
      tableNames: new FormControl(),
    })
    this.formGroup.addControl('config', this.configFormGroup);
    this.configFormGroup.valueChanges.subscribe(v => this.setupContextList());
  }

setupAttributeList() {
  this.getItemMetaData(this.itemName)
    .subscribe(itemMetaData => {
      this.itemMetaData = itemMetaData;
    });
}

static getDisplay(x: any, y: any) { return x.contextDef.contextDisplay + ' ' + y.AttributeDisplay; } 
compareFn(i1: any, i2:any): boolean {
  if (!i1 || !i2) return false;
  const fn = PowerBiConfigComponent.getDisplay;
  const matches: boolean = fn(i1.dwContextMetaData, i1.dwQueryMdAttribute) 
                            == fn(i2.dwContextMetaData, i2.dwQueryMdAttribute);
  return matches; 
}

setupContextList(){
  this.contextNames.forEach(contextName => {
    this.dwContextService.getContextMetaData(contextName).subscribe(x => {
      x.attributes.forEach(y =>{
        this.contextMetaData.push({ dwQueryMdAttribute: y, 
                                    dwContextMetaData: x,
                                    Display: PowerBiConfigComponent.getDisplay(x, y)});
      })
    })
  })
}

}
